import { render, staticRenderFns } from "./ScenarioFinished.vue?vue&type=template&id=2b7b01d4&scoped=true&"
import script from "./ScenarioFinished.vue?vue&type=script&lang=js&"
export * from "./ScenarioFinished.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioFinished.vue?vue&type=style&index=0&id=2b7b01d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b01d4",
  null
  
)

export default component.exports